import { Snackbar, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../store/store";
import { showSnackbar } from "../../store/system.store";

const CustomSnackbar = () => {
  const snackbar = useSelector((state: StoreState) => state.system.snackbar);

  const theme = useTheme();

  const dispatch = useDispatch();
  return (
    <Snackbar
      disableWindowBlurListener
      autoHideDuration={snackbar?.disableAutoHide ? null : 6000}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      open={!!snackbar?.msg}
      sx={{
        "& .MuiPaper-elevation": {
          background: snackbar?.isError
            ? theme.palette.error.main
            : theme.palette.primary.main,
        },
      }}
      onClose={(_, reason) => {
        if (reason !== "clickaway") {
          dispatch(showSnackbar({ msg: "", isError: false }));
        }
      }}
      message={snackbar?.msg}
    ></Snackbar>
  );
};

export default CustomSnackbar;
